import React, { useState } from 'react';

import discord from './assets/discord.png';
import style from './DiscordCard.module.less';

import { DiscordModal } from '../DiscordModal';

export const DiscordCard: React.FC = () => {
  const [modalVisible, setModalVisible] = useState(false);
  return (
    <>
      <div className={style.newsletterCard}>
        <div className={style.wrapper}>
          <div className={style.buttonWrapper}>
            <a onClick={() => setModalVisible(true)}  className={style.button}>
              <div className={style.buttonContent}>
                <div>
                  <img src={discord} alt="discord" />
                </div>
                <div className={style.text}>
                  Join our Discord
                </div>
              </div>
            </a>
          </div>
        </div>
      </div>
      <DiscordModal isOpen={modalVisible} onClose={() => setModalVisible(false)} />
    </>
  );
};
